import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { ConsultaAtendimentoPfRequest, Types } from './types';

// ACTIONS
import {
	consultaAtendimentoPfSuccess,
	consultaAtendimentoPfFailure,
} from './actions';

function* consultaAtendimentoPfRequest(request: ReducerAction) {
	const { payload }: { payload: ConsultaAtendimentoPfRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos-cip/${CHANNEL}/consumidores-pf/consulta-cip`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaAtendimentoPfSuccess(response));
	} else {
		yield put(consultaAtendimentoPfFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_ATENDIMENTO_PF_REQUEST,
		consultaAtendimentoPfRequest,
	),
]);
